import "regenerator-runtime/runtime"
import "./gallery-photo.scss"
import "./description.scss"
import "./comments.scss"
import GalleryPhotoComponent from "./js/gallery-photo"
import { PHOTO } from "./js/constants"

/**
 * @export
 * @param {Object} settings
 * @param {string} settings.token
 * @param {string} settings.location
 * @param {boolean} settings.loggedIn
 * @param {boolean} settings.memberMode
 * @returns
 */
export default async function run(settings) {
  const photoElement = document.querySelector(PHOTO)
  if (!photoElement) return null

  // Get location from data attribute if not provided in settings
  let location = settings.location

  // If location is an object, extract filename_part
  if (location && typeof location === "object" && location.filename_part) {
    location = location.filename_part
  }

  // Fall back to data attribute
  if (!location) {
    location = photoElement.dataset.location
  }

  if (!location) {
    console.warn("Gallery photo component: location is required but not provided")
    return null
  }

  const galleryPhoto = new GalleryPhotoComponent({
    htmlElement: document,
    ...settings,
    location,
  })

  await galleryPhoto.preload(galleryPhoto.state.currentPhoto.id)

  return galleryPhoto
}
